/**
 * Ventana de cierre de una OT que resuelve un aviso a sala (spec 2026-11-02,
 * § 4.4). Una OT cerrada se ofrece para el aviso si se cerró a partir de
 * `hora del aviso − tolerancia`: la hora del aviso es la del tramo y el
 * cierre puede quedar unos minutos por detrás o por delante.
 */

/** Misma tolerancia que el back (`AVISO_CLOSE_TOLERANCE_MINUTES`). */
export const AVISO_CLOSE_TOLERANCE_MINUTES = 5;

const TOLERANCE_MS = AVISO_CLOSE_TOLERANCE_MINUTES * 60_000;

/**
 * Instante mínimo de cierre que se pide al servidor (`closedNotBefore`).
 * Sin hora del aviso se usa `now`: solo se ofrecen las cerradas hace menos
 * de la tolerancia. `now` lo pone quien llama, una vez, para que el valor
 * sea estable mientras la ventana está abierta.
 */
export function closedNotBeforeFor(
  avisoAt: string | null | undefined,
  now: Date,
): string {
  // Un `avisoAt` ilegible se trata como ausente: `toISOString()` lanzaría
  // RangeError (y esto corre en un inicializador de useState).
  const parsed = avisoAt ? new Date(avisoAt) : now;
  const base = Number.isNaN(parsed.getTime()) ? now : parsed;
  return new Date(base.getTime() - TOLERANCE_MS).toISOString();
}

/**
 * Hora final máxima que puede tener un aviso cuya OT se cerró en `closedAt`.
 * Un `closedAt` ilegible devuelve `null`: se trata como una cerrada antigua
 * (sin hora de cierre conocida), que no se ofrece.
 */
export function maxAvisoEndDateFor(closedAt: string): string | null {
  const ms = new Date(closedAt).getTime();
  if (Number.isNaN(ms)) return null;
  return new Date(ms + TOLERANCE_MS).toISOString();
}

/** El menor de los dos instantes; `a` vacío devuelve `b`. */
export function earlierIso(a: string | null | undefined, b: string): string {
  if (!a) return b;
  return new Date(a).getTime() <= new Date(b).getTime() ? a : b;
}
